import RestClient from "../rest.client"

export default class PermissionsService {
    static async assignNotification(deviceId: number, notificationId: number) {
        return await RestClient.call({
            url: '/permissions',
            method: 'post',
            headers: { 'Authorization': localStorage.getItem('token') },
            data: {
                deviceId,
                notificationId
            }
        })
    }
    static async assignGeofence(deviceId: number, geofenceId: number) {
        return await RestClient.call({
            url: '/permissions',
            method: 'post',
            headers: { 'Authorization': localStorage.getItem('token') },
            data: {
                deviceId,
                geofenceId
            }
        })
    }
} 